<template>
  <section class="container mx-auto px-5 lg:px-0 py-8">
    <header>
      <MainTitle el="h1" class="font-extrabold font-body uppercase">
        <template #before>
          {{ $t('pre-title') }}
        </template>
        {{ $t('title') }}
      </MainTitle>
    </header>

    <nav class="mt-12">
      <ul class="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 md:gap-8">
        <li
          v-for="(retailer, index) in retailers"
          :key="retailer?.id ?? index"
          class="p-6 rounded-2xs shadow-custom-9 flex flex-col"
        >
          <img :src="retailer?.icon ?? ''" :alt="retailer?.name ?? ''" class="mx-auto h-16 object-contain" />
          <h2 class="text-lg font-bold mt-[30px] text-center text-primary-A900">
            {{ retailer?.name ?? '' }}
          </h2>
          <a
            target="_blank"
            :href="retailer?.url ?? ''"
            class="mt-2 text-center text-primary-500 underline flex items-center justify-center gap-x-2"
          >
            <svg-icon name="link" class="h-5 w-5" />
            {{ $t('shopFrom', { title: retailer?.name }) }}
          </a>
        </li>
      </ul>
    </nav>
  </section>
</template>
<script setup lang="ts">
const { t: $t } = useI18n({
  useScope: 'local',
});

const { retailers } = useRetailers();
</script>

<i18n lang="json">
{
  "en": {
    "pre-title": "Third Party  ",
    "title": "Platforms",
    "shopFrom": "Shop from {title}"
  },
  "ar": {
    "pre-title": "منصات",
    "title": "التجارة الإلكترونية",
    "shopFrom": "تسوق من {title}"
  }
}
</i18n>

<style lang="postcss" scoped>
@screen md {
  .container {
    max-width: 1168px;
  }
}
</style>
